import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { errMsg } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=anon, obj=auth
  const [error, setError] = useState("");

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("vp_token")) {
      fetchMe();
    } else {
      setUser(null);
    }
  }, [fetchMe]);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("vp_token", data.token);
      setUser(data.user);
      return true;
    } catch (e) {
      setError(errMsg(e, "Credenciais inválidas"));
      return false;
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("vp_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, error, setError, refreshUser: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}
